import { events } from '@estee/elc-service-bus';

import { EventRepository } from '~repositories/EventRepository';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { Event } from '~entities/Event';

interface defaultPayload {
    nonInteraction: boolean;
}
export class CartOverlayOpened {
    private eventRepository: EventRepository;
    private nonInteraction: boolean;

    constructor({ nonInteraction }: defaultPayload) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.nonInteraction = nonInteraction;
    }

    public execute = async () => {
        const payload = {
            event_name: 'checkout_basket',
            event_category: 'viewcart',
            event_action: 'view_cart',
            event_label: 'view_cart_overlay',
            event_noninteraction: this.nonInteraction
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.CART_OVERLAY_OPENED,
            type: 'link',
            payload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
